import { render, staticRenderFns } from "./InputWidget.vue?vue&type=template&id=0a6f1e45&lang=pug&"
import script from "./InputWidget.vue?vue&type=script&lang=js&"
export * from "./InputWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports